import { Controller } from "@hotwired/stimulus"

// Enables the "Call ..." buttons in the MOET drawer only when the override
// checkbox is checked. Buttons stay disabled by default when the claim's
// facility is missing charity care thresholds or a ready charity care form.
export default class extends Controller {
  static targets = ["checkbox", "button"];

  connect() {
    this.toggle()
  }

  toggle() {
    const enable = this.hasCheckboxTarget ? this.checkboxTarget.checked : true
    this.buttonTargets.forEach(button => {
      button.disabled = !enable
    })
  }
}
